export const performances: Performance[] = [{
  playTime: '04:24',
  title: 'Beth Orthon - She cries your name',
  artist: 'Beth',
  location: 'Effenaar Eindhoven',
  image: require('@/assets/images/beth.jpg'),
  url: 'http://dmcuap31aqjkj.cloudfront.net/beth.mp4',
  uuid: 'hfyr73jdh78',
}, {
  playTime: '07:02',
  title: "Descendents - Catalina",
  artist: 'Descendents',
  location: 'Effenaar Eindhoven',
  image: require('@/assets/images/descendents.jpg'),
  url: 'http://dmcuap31aqjkj.cloudfront.net/descendents.mp4',
  uuid: 'jd74hdt3kf',
}, {
  playTime: '04:27',
  title: 'Weezer - Jamie',
  artist: 'Weezer',
  location: 'Effenaar Eindhoven',
  image: require('@/assets/images/weezer.jpg'),
  url: 'http://dmcuap31aqjkj.cloudfront.net/weezer.mp4',
  uuid: 'fjrugkd8f8',
}];

interface Performance {
  playTime: string;
  title: string;
  artist: string;
  location: string;
  image: string;
  url?: string;
  uuid: string;
}